import React, { useState, ChangeEvent, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthApi from '../../api/platform/authApi';
import logo from '../../assets/images/logo-transparent.png';
import { useSystemError } from '../../components/Error/SystemErrorContext';
import styles from '../../css/auth/auth.module.css';
import { ResponseErrorModel } from '../../models/system/responseErrorModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import { handleError, mapResponseErrorToSystemError, mapUnknownErrorToSystemError } from '../../utils/errorUtils';

const PasswordRequestReset: React.FC = () => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [didErrorOccur, setDidErrorOccur] = useState(false);
  const { triggerSystemError } = useSystemError();

  const fetchRequestPasswordReset = async () => {
    try {
      const response = await AuthApi.requestResetPassword(email);

      if (response.success) {
        const data = (response as ResponseSuccessModel).data;
        navigate(`/auth/message/${data.auth_type}`);
      } else {
        handleError(mapResponseErrorToSystemError(response as ResponseErrorModel), setErrorMessage, setDidErrorOccur, triggerSystemError);
      }
    } catch (error: any) {
      handleError(mapUnknownErrorToSystemError(error, false), setErrorMessage, setDidErrorOccur, triggerSystemError);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setErrorMessage(null);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email) {
      setErrorMessage('Please enter your email address');
      return;
    }

    if (!isSubmitting) {
      setIsSubmitting(true);
      await fetchRequestPasswordReset();
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.card}>
        <img src={logo} alt="Medical Device IQ" className={styles.logo} />
        <h2>Request Password Reset</h2>
        <form onSubmit={handleSubmit} className={styles.formContainer}>
          <div className={styles.formGroup}>
            <input
              type="email"
              id="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="Enter your email"
              disabled={isSubmitting}
            />
          </div>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Requesting...' : 'Request Reset'}
          </button>
          {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
        </form>
      </div>
      <div className={styles.registerLinkOuter}>
        <p>Want to return to the home page? <Link to="/">Click here</Link></p>
      </div>
    </div>
  );
};

export default PasswordRequestReset;
